import { Type } from 'class-transformer';
import {
  IsArray,
  IsBoolean,
  IsInt,
  IsOptional,
  IsString,
  IsUrl,
  MaxLength,
  MinLength,
  ValidateNested,
} from 'class-validator';

export class KnowledgeLinkDto {
  @IsString()
  @MinLength(1)
  @MaxLength(120)
  label!: string;

  @IsUrl({ require_tld: false })
  url!: string;
}

export class CreateKnowledgeEntryDto {
  @IsString()
  @MinLength(1)
  @MaxLength(500)
  question!: string;

  @IsString()
  @MinLength(1)
  @MaxLength(4000)
  answer!: string;

  @IsArray()
  @IsString({ each: true })
  keywords!: string[];

  @IsOptional()
  @IsArray()
  @ValidateNested({ each: true })
  @Type(() => KnowledgeLinkDto)
  links?: KnowledgeLinkDto[];

  @IsOptional()
  @IsInt()
  sortOrder?: number;
}

export class UpdateKnowledgeEntryDto {
  @IsOptional()
  @IsString()
  @MinLength(1)
  @MaxLength(500)
  question?: string;

  @IsOptional()
  @IsString()
  @MinLength(1)
  @MaxLength(4000)
  answer?: string;

  @IsOptional()
  @IsArray()
  @IsString({ each: true })
  keywords?: string[];

  @IsOptional()
  @IsArray()
  @ValidateNested({ each: true })
  @Type(() => KnowledgeLinkDto)
  links?: KnowledgeLinkDto[];

  @IsOptional()
  @IsBoolean()
  isActive?: boolean;

  @IsOptional()
  @IsInt()
  sortOrder?: number;
}
